import useDocumentTitle from 'hooks/useDocumentTitle';
import React from 'react'

const SupplierGroup = () => {
  useDocumentTitle("Supplier Group | T360");

  return (
    <div>SupplierGroup</div>
  )
}

export default SupplierGroup